import { Box, Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import SearchInput from '../../common/components/SearchInput';
import { ProductFamily } from '../../hooks/useSortedProductFamiliesMap';
import FilterDisplay, { FilterDisplayMode } from '../../search/filters/FilterDisplay';

interface ProductSubFamilyFilterProps {
  productFamilyMap: ProductFamily[];
  selectedProductFamilyMap?: ProductFamily[];
  onChange?: (values: ProductFamily[]) => void;
  mode?: FilterDisplayMode;
}

export default function ProductSubFamilyFilter({ productFamilyMap, selectedProductFamilyMap, onChange, mode = 'POPOVER' }: ProductSubFamilyFilterProps): React.JSX.Element {
  const { t } = useTranslation(['discovery']);
  const [itemQuery, setItemQuery] = useState('');
  const [values, setValues] = useState<ProductFamily[]>(selectedProductFamilyMap || []);

  const handleToggle = (option: ProductFamily): void => {
    const newValues = [...values];
    const foundIndex = newValues.findIndex(({ value }) => value === option.value);

    if (foundIndex === -1) {
      newValues.push(option);
    } else {
      newValues.splice(foundIndex, 1);
    }

    setValues(newValues);

    if (onChange) {
      onChange(newValues);
    }
  };

  useEffect(() => {
    setValues(selectedProductFamilyMap || []);
  }, [selectedProductFamilyMap]);

  const filterContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={{ mb: 1 }} variant="titleMedium">{t('discovery:select_one_or_several_departments')}</Typography>
      <SearchInput
        fullWidth
        value={itemQuery}
        onChange={setItemQuery}
        placeholder={t('discovery:search_a_particular_departement')}
        sx={{ mb: 1 }}
      />
      <List>
        {(productFamilyMap as ProductFamily[])
          .filter((value) => value.label.toLowerCase().indexOf(itemQuery.toLowerCase()) === 0)
          .map((option) => (
            <ListItemButton
              key={option.value}
              onClick={() => handleToggle(option)}
            >
              <ListItemText primary={option.label} />
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={!!values.find(({ value }) => value === option.value)}
                />
              </ListItemIcon>
            </ListItemButton>
          ))}
      </List>
    </Box>
  );

  return (
    <FilterDisplay
      mode={mode}
      name="subFamiliesFilter"
      activeItemCount={values.length}
      icon={<ShoppingBasketOutlinedIcon />}
      label={t('discovery:departments')}
      content={filterContent}
    />
  );
}
